//songs data

import { v4 as uuidv4 } from "uuid"
export default function chillHop() {
    return [
        {
            name: "A Reminder",
            artist: "Sleepy Fish, coa",
            cover: "https://chillhop.com/wp-content/uploads/2022/05/c0c6175640eb9aa14b955ae91e255b3175de1c32-1024x1024.jpg",
            id: uuidv4(),
            color: ['#EDB56B', '#B10101'],
            audio: "https://mp3.chillhop.com/serve.php/?mp3=36925",
            active: true


        },

        {
            name: "Low Tide",
            artist: "Yasper, chromonicci",
            cover: "https://chillhop.com/wp-content/uploads/2022/05/18d934ab6d70d065944aabf9a05bef2a06ce770d-1024x1024.jpg",
            id: uuidv4(),
            color: ['#D39701', '#021F3D'],
            audio: "https://mp3.chillhop.com/serve.php/?mp3=36940",
            active: false


        },

        {
            name: "Rooftop Breeze",
            artist: "Smile High, Richard Vagner",
            cover: "https://chillhop.com/wp-content/uploads/2022/05/42878bcb02c1a3613f4913b226674cd36bac9830-1024x1024.jpg",
            id: uuidv4(),
            color: ['#070C16', '#274275'],
            audio: "https://mp3.chillhop.com/serve.php/?mp3=36650",
            active: false


        },

        {
            name: "Barcade",
            artist: "Philanthrope, Ian Ewing",
            cover: "https://chillhop.com/wp-content/uploads/2022/04/73f23095038f6f023083520706f3e5345f5dd682-1024x1024.jpg",
            id: uuidv4(),
            color: ['#9FCEE6', '#754B4D'],
            audio: "https://mp3.chillhop.com/serve.php/?mp3=32849",
            active: false
        },

        {
            name: "Blue Moment",
            artist: "Sugi.wa, Tom Ford",
            cover: "https://chillhop.com/wp-content/uploads/2022/04/7e2c880b50c6647e59330b1c371101ce2950625f-1024x1024.jpg",
            id: uuidv4(),
            color: ['#92A199', '#D8B301'],
            audio: "https://mp3.chillhop.com/serve.php/?mp3=32978",
            active: false
        },

        {
            name: "Nectarine",
            artist: "Es-K, Danny James, John Culbreth",
            cover: "https://chillhop.com/wp-content/uploads/2022/06/2b9d337d372db542748e2643dc90af62dd3418e2-1024x1024.jpg",
            id: uuidv4(),
            color: ['#AE0303', '#627641'],
            audio: "https://mp3.chillhop.com/serve.php/?mp3=34242",
            active: false
        },

          {
            name: "Lose Her Way",
            artist: "C Y G N",
            cover: "https://chillhop.com/wp-content/uploads/2022/04/8cc8bdc59b30dd1f9d401cb485b8537d909e1f50-1024x1024.jpg",
            id: uuidv4(),
            color: ['#2D9E34', '#838F83'],
            audio: "https://mp3.chillhop.com/serve.php/?mp3=31589",
            active: false
        },

        {
            name: "Fireworks Festival",
            artist: "Sleepy Fish",
            cover: "https://chillhop.com/wp-content/uploads/2021/09/2ce75252f5419a45d76bb93424ac1eae3e688b17-1024x1024.jpg",
            id: uuidv4(),
            color: ['#FEBD9A', '#102444'],
            audio: "https://mp3.chillhop.com/serve.php/?mp3=31589",
            active: false
        },
        
        {
            name: "Perfect Storm",
            artist: "Aviino",
            cover: "https://chillhop.com/wp-content/uploads/2021/09/a2d710149876c8e0c9fb097840b2438fbc21bd37-1024x1024.jpg",
            id: uuidv4(),
            color: ['#FCF39C', '#946C58'],
            audio: "https://mp3.chillhop.com/serve.php/?mp3=23057",
            active: false
        },
        
        
    ]
}
